import { PayloadAction } from '@reduxjs/toolkit';
import { call, put } from 'redux-saga/effects';

import { httpClient } from 'services/httpClient';

import { interventionActions } from '..';

import { IAddWorkerToInterventionRequestAction } from '../reducers/addWorker/request';

function* addWorker(
  action: PayloadAction<IAddWorkerToInterventionRequestAction>,
) {
  try {
    yield call(
      httpClient.put,
      `/rik/v1/workers/${action.payload.data.id}/add_intervention`,
      {
        intervention_id: action.payload.data.intervention_id,
      },
    );

    yield put(
      interventionActions.addWorkerSuccess({
        id: parseInt(action.payload.data.id, 10),
      }),
    );
  } catch (error) {
    action.payload.functions.error(error);
    yield put(interventionActions.addWorkerFailure());
  }
}

export default addWorker;
